(() => {
  const slugify = (text) =>
    String(text || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

  const getStickyHeaderHeight = () => {
    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');
    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    return Math.max(0, Math.round(rect.height || 0));
  };

  const setHeaderOffsetVar = () => {
    const height = getStickyHeaderHeight();
    document.documentElement.style.setProperty('--ep-sticky-header-height', `${height}px`);
  };

  const initReadingProgress = () => {
    const wrapper = document.querySelector('[data-ep-reading-progress]');
    const bar = document.querySelector('[data-ep-reading-progress-bar]');
    const content = document.querySelector('.ep-article-content');
    if (!wrapper || !bar || !content) return;

    let rafId = null;

    const update = () => {
      rafId = null;
      const docTop = window.scrollY || window.pageYOffset || 0;
      const viewport = window.innerHeight || 0;

      const contentTop = content.getBoundingClientRect().top + docTop;
      const contentHeight = content.scrollHeight || content.offsetHeight || 0;
      const start = contentTop - 0.2 * viewport;
      const end = contentTop + contentHeight - 0.6 * viewport;

      const raw = (docTop - start) / Math.max(1, end - start);
      const progress = Math.min(1, Math.max(0, raw));
      bar.style.transform = `scaleX(${progress})`;
      wrapper.classList.toggle('is-visible', progress > 0.01);
    };

    const onScroll = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      setHeaderOffsetVar();
      onScroll();
    });
  };

  const initTOC = () => {
    const toc = document.querySelector('[data-ep-toc]');
    const list = document.querySelector('[data-ep-toc-list]');
    const content = document.querySelector('.ep-article-content');
    if (!toc || !list || !content) return;

    const headings = Array.from(content.querySelectorAll('h2, h3')).filter((h) =>
      (h.textContent || '').trim()
    );
    if (!headings.length) {
      toc.hidden = true;
      return;
    }

    const usedIds = new Set();
    headings.forEach((h) => {
      if (h.id) usedIds.add(h.id);
    });

    const ensureId = (heading) => {
      if (heading.id) return heading.id;
      const base = slugify(heading.textContent);
      let id = base || 'section';
      let i = 2;
      while (usedIds.has(id)) {
        id = `${base || 'section'}-${i}`;
        i += 1;
      }
      usedIds.add(id);
      heading.id = id;
      return id;
    };

    list.innerHTML = '';
    headings.forEach((heading) => {
      const id = ensureId(heading);
      const li = document.createElement('li');
      li.className = heading.tagName.toLowerCase() === 'h3' ? 'ep-article-toc__item is-h3' : 'ep-article-toc__item';
      const a = document.createElement('a');
      a.className = 'ep-article-toc__link';
      a.href = `#${id}`;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });

    const details = toc.querySelector('details');
    if (details) {
      details.open = window.matchMedia('(min-width: 990px)').matches;
    }
  };

  const initInlineNewsletter = () => {
    const template = document.querySelector('[data-ep-inline-newsletter-template]');
    const content = document.querySelector('.ep-article-content');
    if (!template || !content) return;

    const after = Number(template.getAttribute('data-ep-inline-after')) || 3;
    const paras = Array.from(content.querySelectorAll('p')).filter((p) => (p.textContent || '').trim());
    if (paras.length < after) return;

    const mount = template.cloneNode(true);
    mount.removeAttribute('hidden');
    mount.removeAttribute('data-ep-inline-newsletter-template');
    mount.classList.add('ep-article-inline-newsletter');
    mount.removeAttribute('data-ep-inline-after');
    paras[after - 1].insertAdjacentElement('afterend', mount);
  };

  document.addEventListener('DOMContentLoaded', () => {
    setHeaderOffsetVar();
    initReadingProgress();
    initTOC();
    initInlineNewsletter();
  });
})();
